import script from "./MenubarSubTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./MenubarSubTrigger.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__